<div class="section-input-type-container p-4">
    <div class="d-flex items-center w-full px-6">
        <h3 class="label-02 font-bold mb-1">{{field.props.label}}</h3>
        <!-- (click)="addFieldForStepBuilder($event)"  -->
        <button [matMenuTriggerFor]="stepFieldsMenu" type="button" mat-flat-button color="primary"
          class="btn btn-primary btn-with-icon ml-auto">
          <mat-icon>add</mat-icon>
          {{ field.props.addText }}
        </button>
  
        <mat-menu class="step-fields" #stepFieldsMenu="matMenu">
          <button mat-button (click)="addItem(type)"  class="step-fields-item btn-with-icon d-flex flex-1 btn" *ngFor="let type of field.fieldArray.fieldGroup">
                <mat-icon class="input-type-icon">
                    {{type.props.studioIcon}}
                </mat-icon>
                <p class="text-sm mb-0 input-type-name">
                    {{type.props.studioInputName}}
                </p> 
            </button>
        </mat-menu>
    </div>

      <ng-container>
        <div class="field-container" *ngIf="field.fieldGroup.length > 0; else emptyState">
            <ng-container *ngFor="let currentField of field.fieldGroup; let i = index;">
              <div class="section-child-field form-params-group-with-button">
                <formly-field [field]="currentField"></formly-field>
                <button mat-flat-button type="button" class="btn btn-danger mt-4 delete-row  btn-with-icon" (click)="remove(i)">
                  <mat-icon>delete</mat-icon> {{field.props.deleteButtonLabel || 'Delete'}}
                </button>
              </div>
            </ng-container>
          </div>
      </ng-container>
</div>


<ng-template #emptyState>
    <p class="empty-state-text d-flex justify-center mt-12">No child input elements added</p>
  </ng-template>
  
